import React from 'react'

import { connect } from 'react-redux'

import { withRouter } from 'react-router-dom'

import { getPermissions } from '../actions'

import {
    Tag,
    Table,
    Card,
    Row,
    Col,
    Divider,
    Popconfirm,
    Button
} from 'antd'

import PermissionsModal from './modal'

import {
    setActivePermission,
    removePermission
} from '../actions'

class AdminPermissions extends React.Component {
    render(){

        const {
            renderAddModal,
            addModalVisible
        } = this.state

        return(
            <Card 
            title={
                <Row type="flex" justify="space-between" align="middle">
                    <Col>
                        Configure Permissions
                    </Col>
                    <Col>
                        <Button 
                        onClick={this.handleOpenModal}
                        type="primary">
                            Add
                        </Button>
                    </Col>
                </Row>
            }
            type="inner">
                {renderAddModal && 
                    <PermissionsModal
                        visible={addModalVisible}
                        onCancel={this.handleCloseModal}
                        afterClose={this.handleAfterCloseModal}    
                    />}
                <Table
                    columns={[{
                        title: 'Name',
                        dataIndex: 'title'
                    },{
                        title: 'Pages',
                        dataIndex: 'pages',
                        width: '75%',
                        render:(pages)=> {
                            return (
                                <Row type="flex" gutter={4}>
                                    {pages.map( _page => (
                                        <Col>
                                            <Tag style={{marginBottom: 8}}>{_page.kebabName}</Tag>
                                        </Col>
                                    ))}
                                </Row>
                            )
                        }
                    },{
                        title: 'Actions',
                        render:(record) => {
                            return (
                                <span>
                                    <a
                                        onClick={()=>this.handleEdit(record)}
                                    >Edit</a>
                                    <Divider type="vertical"/>
                                    <Popconfirm
                                        title="Are you sure?"
                                        onConfirm={()=>this.handleRemove(record)}
                                    >
                                        <a>
                                            Remove
                                        </a>
                                    </Popconfirm>
                                </span>
                            )
                        }
                    }]}
                    dataSource={this.props.permissions}
                />
            </Card>
        )
    }

    constructor(props){
        super(props)

        this.state = {
            renderAddModal: false,
            addModalVisible: false
        }

        this.props.getPermissions()
        
    }

    handleOpenModal = () => {
        this.setState({
            renderAddModal: true,
            addModalVisible: true
        })
    }

    handleCloseModal = () => {
        this.setState({
            addModalVisible: false
        })
    }

    handleAfterCloseModal = () => {
        
        this.props.setActivePermission({})
        
        this.setState({
            renderAddModal: false
        })
    }

    handleRemove = (permission) => {

        this.props.removePermission(permission._id)

    }

    handleEdit = (permission) => {

        this.props.setActivePermission(permission)

        this.handleOpenModal()
    }
}

export default connect(
    state => ({
        permissions: state.admins.permissions
    }),
    dispatchEvent => ({
        removePermission: (permissionId) => dispatchEvent(removePermission(permissionId)),
        getPermissions: () => dispatchEvent(getPermissions()),
        setActivePermission: (permission) => dispatchEvent(setActivePermission(permission))
    })
)(withRouter(AdminPermissions))


// WEBPACK FOOTER //
// ./src/components/admin/permissions/index.js